import { getMembershipStatus, getStatusTone, formatStatus } from '@/utils';
import { Badge } from '@/components/ui';


interface MembershipStatusBadgeProps {
  membership: {
    start_date: string | null;
    end_date: string | null;
    name?: string;
    status?: string;
    cancelled_at?: string | null;
  } | null;
  className?: string;
  isLoading?: boolean;
}

export default function MembershipStatusBadge({ 
  membership, 
  className = "",
  isLoading = false
}: MembershipStatusBadgeProps) {
  // Handle loading state
  if (isLoading) {
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-400 animate-pulse ${className}`}>
        Loading...
      </span>
    );
  }

  // Handle null membership
  if (!membership) {
    return (
      <Badge tone="red" className={className}>
        No Membership
      </Badge>
    );
  }

  // Handle null dates
  if (!membership.start_date || !membership.end_date) {
    return (
      <Badge tone="red" className={className}>
        No Membership
      </Badge>
    );
  }

  const displayStatus = getMembershipStatus(membership);

  return (
    <Badge tone={getStatusTone(displayStatus)} className={className}>
      {membership.name ? `${membership.name} - ` : ''}{formatStatus(displayStatus)}
    </Badge>
  );
} 